import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/cms-base.css";
import "./styles/cms-forms.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { cmsRoutes } from "./routes";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";

export default function CmsApp(){
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const isLogin = /\/cms\/login$/.test(loc.pathname);
  return (
    <div className="cms-app">
      {!isLogin && <aside className={`cms-sidebar ${open? 'show':''}`}><Sidebar/></aside>}
      <main className="cms-main">
        {!isLogin && <div className="cms-top"><Topbar onMenu={()=>setOpen(true)}/></div>}
        {open && <div className="cms-overlay d-lg-none" onClick={()=>setOpen(false)}></div>}
        <div className="cms-container container-fluid">
          <Routes>
            {cmsRoutes.map(r=> <Route key={r.path||'root'} path={r.path} element={r.element}/>)}
            {/* 존재하지 않는 경로 → 게시물 관리로 */}
            <Route path="*" element={<Navigate to="/cms/boards/post" replace/>} />
          </Routes>
        </div>
      </main>
    </div>
  );
}
